/**
 * How the 3D view draws, a per-machine preference both platforms offer in
 * their View menus. Both qualities shade by the one scene light (see
 * sceneLighting.ts). High is the full pipeline: a G-buffer, ambient
 * occlusion and its blur. Low draws the same light straight to the screen
 * with no effects, for slower devices. Where High cannot draw (no WebGL2
 * float color buffers), the view draws Low.
 */

export type View3DQuality = 'low' | 'high';

export const DEFAULT_VIEW3D_QUALITY: View3DQuality = 'high';

/** The qualities the View menus offer, in menu order, with their labels. */
export const VIEW3D_QUALITY_CHOICES: readonly (readonly [View3DQuality, string])[] = [['low', 'Low'], ['high', 'High']];

/** The quality read back from a saved preference: anything this version doesn't know draws High. */
export const parseView3DQuality = (stored: unknown): View3DQuality =>
  VIEW3D_QUALITY_CHOICES.find(([quality]) => quality === stored)?.[0] ?? DEFAULT_VIEW3D_QUALITY;
